/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import GoogleMapPage from "../../../components/Map/GoogleMap";
import { toast } from "react-toastify";
import { dummyimage } from "../../../assets/img";
import OverallPropertiesList from "../../OverallProperties/OverallPropertiesList";
import { useGlobalContext } from "../../../Services/PaginationGlobal";

const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

const UserForm = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [isOn, setIsOn] = useState(false);
  const [isOnbank, setIsOnBank] = useState(false);
  const [address, setAddress] = useState({});
  const [label, setIsLabel] = useState(
    paginationData?.[path]?.tab ?? "Owner Details",
  );
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [areaOptions, setAreaOptions] = useState([]);
  const imgRef = useRef(null);
  const [profile_img, setProfile_img] = useState("");

  const Ownerid = location?.state?.id;
  const type = location?.state?.type;
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    resetField,
    reset,
  } = useForm({
    defaultValues: {
      userName: "",
      email: "",
      mobile: "",
      whatsapp: "",
      gender: null,
      nationality: "India",
      state: null,
      city: null,
      area: null,
      googleAddress: "",
      manualAddress: "",
    },
  });
  const isSame = watch("sameAsMobile", false);
  const mobileValue = watch("mobile");

  useEffect(() => {
    if (isSame) {
      setValue("whatsapp", mobileValue);
    }
  }, [isSame, mobileValue, setValue]);

  useEffect(() => {
    if (address) {
      setValue("googleAddress", address?.address);
    }
  }, [address]);

  const stateChange = watch("state");
  const cityChange = watch("city");

  useEffect(() => {
    if (stateChange?.value) {
      getLocationsList(3, stateChange?.value);
    }
  }, [stateChange]);

  useEffect(() => {
    if (cityChange?.value) {
      getLocationsList(4, cityChange?.value);
    }
  }, [cityChange]);

  // FIX 1: Reset GST fields when GST toggle is turned off
  useEffect(() => {
    if (!isOn) {
      resetField("GSTNo");
      resetField("GSTholderName");
      resetField("GSTAddress");
      resetField("GSTContactNo");
      resetField("GSTRegisterMail");
    }
  }, [isOn, resetField]);

  // FIX 2: Reset Bank fields when Bank toggle is turned off
  useEffect(() => {
    if (!isOnbank) {
      resetField("bankName");
      resetField("Branch");
      resetField("IFSCCode");
      resetField("AccountHolderName");
      resetField("AccountNumber");
      resetField("UPIID");
      resetField("GpayNumber");
      resetField("PhonePayNumber");
      resetField("panNumber");
    }
  }, [isOnbank, resetField]);

  const updateOwner = async (data) => {
    let payload = new FormData();

    payload.append("owner", Ownerid);
    payload.append("name", data?.userName || "");
    payload.append("email", data?.email || "");
    payload.append("mobile", data?.mobile || "");
    payload.append("whatsapp_no", data?.whatsapp || "");
    payload.append("gender", data?.gender?.value || "");
    payload.append("address", data?.manualAddress || "");
    payload.append("google_address", address?.address || "");
    payload.append("country", 1);
    payload.append("state", data?.state?.value || "");
    payload.append("city", data?.city?.value || "");
    payload.append("area", data?.area?.value || "");

    if (profile_img instanceof File) {
      payload.append("image", profile_img);
    }

    const gstFields = {
      gst_no: data?.GSTNo || "",
      gst_name: data?.GSTholderName || "",
      gst_address: data?.GSTAddress || "",
      gst_contact_no: data?.GSTContactNo || "",
      gst_mail_id: data?.GSTRegisterMail || "",
    };

    const bankFields = {
      bank_name: data?.bankName || "",
      bank_branch: data?.Branch || "",
      ifsc_code: data?.IFSCCode || "",
      bank_acc_name: data?.AccountHolderName || "",
      bank_acc_no: data?.AccountNumber || "",
      upi_id: data?.UPIID || "",
      gpay_no: data?.GpayNumber || "",
      phone_pay_no: data?.PhonePayNumber || "",
      pan_no: data?.panNumber || "",
    };

    let details = {};

    if (isOn) {
      details = { ...details, ...gstFields };
    }

    if (isOnbank) {
      details = { ...details, ...bankFields };
    }
    if (isOn || isOnbank) {
      payload.append("details", JSON.stringify(details));
    }

    const res = await post(URLS.OWNERS + Ownerid + "/", payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      navigate("/user-owner");
    }
  };

  const onSubmit = async (data) => {
    if (type === "edit") {
      updateOwner(data);
      return;
    }
    const payload = new FormData();
    payload.append("name", data?.userName);
    payload.append("email", data?.email);
    payload.append("mobile", data?.mobile);
    payload.append("whatsapp_no", data?.whatsapp);
    payload.append("gender", data?.gender?.value);
    payload.append("address", data?.manualAddress);
    payload.append("google_address", address?.address);
    payload.append("country", 1);
    payload.append("state", data?.state?.value);
    payload.append("city", data?.city?.value);
    payload.append("area", data?.area?.value);
    if (profile_img) payload.append("image", profile_img);

    const res = await post(URLS.OWNERS, payload);
    if (res?.status === "success") {
      if (isOn || isOnbank) {
        OtherDetailsUpdate(data, res?.data?.id);
      } else {
        toast.success(res?.message);
        navigate("/user-owner");
      }
    }
  };

  const OtherDetailsUpdate = async (data, id) => {
    const payload = new FormData();
    payload.append("owner", id);
    if (isOn) {
      payload.append("gst_no", data?.GSTNo);
      payload.append("gst_name", data?.GSTholderName);
      payload.append("gst_address", data?.GSTAddress);
      payload.append("gst_contact_no", data?.GSTContactNo);
      payload.append("gst_mail_id", data?.GSTRegisterMail);
    }
    if (isOnbank) {
      payload.append("bank_name", data?.bankName);
      payload.append("bank_branch", data?.Branch);
      payload.append("ifsc_code", data?.IFSCCode);
      payload.append("bank_acc_name", data?.AccountHolderName);
      payload.append("bank_acc_no", data?.AccountNumber);
      payload.append("upi_id", data?.UPIID);
      payload.append("gpay_no", data?.GpayNumber);
      payload.append("phone_pay_no", data?.PhonePayNumber);
      payload.append("pan_no", data?.panNumber);
    }

    const res = await post(URLS.OWNER_DETAILS, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      navigate("/user-owner");
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F4F4",
      borderRadius: 4,
      border: "none",
      padding: 5,
      width: "100%",
      boxShadow: "none",
      minHeight: "initial",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#999999",
    }),
  };

  const toggleSwitch = () => {
    if (type === "view") return;
    setIsOn(!isOn);
  };

  const toggleSwitchs = () => {
    if (type === "view") return;
    setIsOnBank(!isOnbank);
  };

  useEffect(() => {
    if (Ownerid) {
      viewUser(Ownerid);
    }
    getLocationsList(2);
  }, [Ownerid]);

  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION + "?type=" + type}${
      parent_id ? "&parent_id=" + parent_id : ""
    }`;
    const res = await get(url);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      if (type === 2) {
        setStateOptions(modifiedList);
      } else if (type === 3) {
        setCityOptions(modifiedList);
      } else {
        setAreaOptions(modifiedList);
      }
    }
  };

  const viewUser = async (id) => {
    const res = await get(URLS.OWNERS + id);
    if (res?.status === "success") {
      let user = res?.data;
      let userDetails = user?.details;
      let obj = {
        userName: user?.name,
        email: user?.email,
        mobile: user?.mobile,
        whatsapp: user?.whatsapp_no,
        sameAsMobile: user?.mobile === user?.whatsapp_no,
        gender: genderOptions.find((item) => item.value === user?.gender),
        nationality: "India",
        state: { value: user?.state, label: user?.state_name },
        city: { value: user?.city, label: user?.city_name },
        area: { value: user?.area, label: user?.area_name },
        googleAddress: user?.google_address,
        manualAddress: user?.address,
      };
      setAddress({ address: user?.google_address });
      setProfile_img(user?.image);
      if (userDetails?.gst_no) {
        setIsOn(true);
        obj = {
          ...obj,
          GSTNo: userDetails?.gst_no,
          GSTholderName: userDetails?.gst_name,
          GSTAddress: userDetails?.gst_address,
          GSTContactNo: userDetails?.gst_contact_no,
          GSTRegisterMail: userDetails?.gst_mail_id,
        };
      }
      if (userDetails?.bank_acc_no) {
        setIsOnBank(true);
        obj = {
          ...obj,
          bankName: userDetails?.bank_name,
          Branch: userDetails?.bank_branch,
          IFSCCode: userDetails?.ifsc_code,
          AccountHolderName: userDetails?.bank_acc_name,
          AccountNumber: userDetails?.bank_acc_no,
          UPIID: userDetails?.upi_id,
          GpayNumber: userDetails?.gpay_no,
          PhonePayNumber: userDetails?.phone_pay_no,
          panNumber: userDetails?.pan_no,
        };
      }
      reset(obj);
    }
  };

  return (
    <>
      <Topbar
        header={"Owner"}
        subHead={`Owner ${
          label === "Owner Details"
            ? type === "view"
              ? "View"
              : type === "edit"
                ? "Edit"
                : "Add"
            : "Properties"
        }`}
      />
      {Ownerid && (
        <div>
          <div className="d-flex gap-3">
            {["Owner Details", "Properties "].map((ele) => (
              <div
                key={ele}
                style={{
                  background: label === ele ? "#6B00D8" : "none",
                  color: label === ele ? "#fff" : "#898989",
                  padding: "10px 16px",
                  borderRadius: 9,
                  fontSize: "16px",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setpaginationData((prev) => ({
                    ...prev,
                    [path]: { ...prev?.[path], tab: ele },
                  }));
                  setIsLabel(ele);
                }}
              >
                {ele}
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="row mt-5">
        {label === "Owner Details" ? (
          <form
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            className="d-flex flex-wrap gap-5"
            onSubmit={handleSubmit(onSubmit)}
          >
            {/* User Name */}
            <div className="col-md-5">
              <Controller
                control={control}
                name="userName"
                disabled={type === "view"}
                rules={{ required: "User name is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      User Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      {...field}
                      className="input-box"
                      placeholder="UserName"
                    />
                    {errors.userName && (
                      <p style={{ color: "red" }}>{errors.userName.message}</p>
                    )}
                  </div>
                )}
              />
            </div>

            {/* Email */}
            <div className="col-md-5">
              <Controller
                control={control}
                name="email"
                disabled={type === "view"}
                rules={{
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email address",
                  },
                }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Email <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      placeholder="Enter Your Email Id"
                      className="input-box"
                      type="email"
                      {...field}
                    />
                    {errors.email && (
                      <p style={{ color: "red" }}>{errors.email.message}</p>
                    )}
                  </div>
                )}
              />
            </div>

            {/* Mobile */}
            <div className="col-md-5">
              <Controller
                control={control}
                name="mobile"
                rules={{
                  required: "Mobile number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Mobile number must be exactly 10 digits",
                  },
                }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Mobile Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      disabled={type === "view" || type === "edit"}
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown")
                          e.preventDefault();
                      }}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                      className="input-box"
                      placeholder="Enter your Mobile No"
                      {...field}
                      readOnly={type === "edit"}
                      type="number"
                    />
                    {errors.mobile && (
                      <p style={{ color: "red" }}>{errors.mobile.message}</p>
                    )}
                  </div>
                )}
              />
            </div>

            {/* WhatsApp */}
            <div className="col-md-5">
              <Controller
                control={control}
                name="whatsapp"
                disabled={type === "view"}
                rules={{
                  required: "WhatsApp number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "WhatsApp number must be exactly 10 digits",
                  },
                }}
                render={({ field }) => (
                  <div>
                    <div
                      style={{ display: "flex", gap: 10, alignItems: "center" }}
                    >
                      <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                        WhatsApp Number (Same as Mobile){" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <span>
                        <Controller
                          control={control}
                          name="sameAsMobile"
                          disabled={type === "view"}
                          render={({ field }) => (
                            <input
                              type="checkbox"
                              {...field}
                              checked={field.value || false}
                            />
                          )}
                        />
                      </span>
                    </div>
                    <input
                      className="input-box"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown")
                          e.preventDefault();
                      }}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                      placeholder="Enter your WhatsApp No"
                      {...field}
                      type="number"
                      readOnly={isSame}
                    />
                    {errors.whatsapp && (
                      <p style={{ color: "red" }}>{errors.whatsapp.message}</p>
                    )}
                  </div>
                )}
              />
            </div>

            {/* Gender */}
            <div className="col-md-5" style={{ zIndex: 4 }}>
              <Controller
                control={control}
                name="gender"
                disabled={type === "view"}
                rules={{ required: "Gender is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Gender <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      {...field}
                      options={genderOptions}
                      isDisabled={type === "view"}
                      placeholder="Select Gender"
                      isSearchable
                      onChange={field.onChange}
                      value={field.value}
                      styles={customStyles}
                    />
                    {errors.gender && (
                      <p style={{ color: "red" }}>{errors.gender.message}</p>
                    )}
                  </div>
                )}
              />
            </div>

            {/* Nationality */}
            <div className="col-md-5">
              <Controller
                control={control}
                name="nationality"
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Nationality <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      className="input-box"
                      {...field}
                      value="India"
                      readOnly
                    />
                  </div>
                )}
              />
            </div>

            {/* State */}
            <div className="col-md-5" style={{ zIndex: 3 }}>
              <Controller
                control={control}
                name="state"
                disabled={type === "view"}
                rules={{ required: "State is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      State <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      {...field}
                      isDisabled={type === "view"}
                      options={stateOptions}
                      placeholder="Select State"
                      isSearchable
                      onChange={(e) => {
                        field.onChange(e);
                        setCityOptions([]);
                        setAreaOptions([]);
                        setValue("city", null);
                        setValue("area", null);
                      }}
                      value={field.value}
                      styles={customStyles}
                    />
                    {errors.state && (
                      <p style={{ color: "red" }}>{errors.state.message}</p>
                    )}
                  </div>
                )}
              />
            </div>

            {/* City */}
            <div className="col-md-5">
              <Controller
                control={control}
                name="city"
                disabled={type === "view"}
                rules={{ required: "City is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      City <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      {...field}
                      isDisabled={type === "view"}
                      options={cityOptions}
                      placeholder="Select City"
                      isSearchable
                      onChange={(e) => {
                        field.onChange(e);
                        setAreaOptions([]);
                        setValue("area", null);
                      }}
                      value={field.value}
                      styles={customStyles}
                    />
                    {errors.city && (
                      <p style={{ color: "red" }}>{errors.city.message}</p>
                    )}
                  </div>
                )}
              />
            </div>

            {/* Area — FIX 3: removed incorrect required rule (label shows it's optional) */}
            <div className="col-md-5" style={{ zIndex: 2 }}>
              <Controller
                control={control}
                name="area"
                disabled={type === "view"}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Area
                    </label>
                    <Select
                      {...field}
                      isDisabled={type === "view"}
                      options={areaOptions}
                      placeholder="Select Area"
                      isSearchable
                      isClearable
                      onChange={field.onChange}
                      value={field.value}
                      styles={customStyles}
                    />
                    {errors.area && (
                      <p style={{ color: "red" }}>{errors.area.message}</p>
                    )}
                  </div>
                )}
              />
            </div>

            {/* FIX 4: Profile Image — was incorrectly using name="area", now uses name="profileImage" */}
            <div className="col-md-5">
              <div className="col-md-6 mb-3">
                <label className="fw-semibold">Profile Image</label>
                <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mb-1 red">
                  Max Upload Size : 5MB
                </p>
                <div className="d-flex flex-column as-jc position-relative">
                  <img
                    onClick={() => {
                      if (type !== "view") imgRef.current?.click();
                    }}
                    src={
                      profile_img
                        ? typeof profile_img === "string"
                          ? profile_img
                          : URL.createObjectURL(profile_img)
                        : dummyimage
                    }
                    style={{
                      width: "100px",
                      height: "90px",
                      borderRadius: "50px",
                      cursor: type !== "view" ? "pointer" : "default",
                    }}
                    alt="Profile"
                  />
                  <input
                    ref={imgRef}
                    type="file"
                    className="input-pop mt-2 w-100 d-none"
                    accept="image/*"
                    disabled={type === "view"}
                    onChange={(e) => {
                      if (e.target.files && e.target.files.length > 0) {
                        setProfile_img(e.target.files[0]);
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Google Map */}
            <div className="col-md-11">
              <div className="w-90">
                <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  Google Map Address
                </label>
                <div
                  style={{
                    overflow: "hidden",
                    borderRadius: 10,
                    position: "relative",
                  }}
                >
                  <GoogleMapPage
                    edit={type !== "view"}
                    formData={address}
                    setFormData={setAddress}
                  />
                </div>
              </div>
            </div>

            {/* FIX 5: Google address display field — was incorrectly using name="googleAddress" with required rule,
                now correctly bound to "googleAddress" as read-only display */}
            <div className="col-md-11">
              <Controller
                control={control}
                name="googleAddress"
                disabled={true}
                render={({ field }) => (
                  <div style={{ width: "95%" }}>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Head/ Owner (Google Map address)
                    </label>
                    <input
                      className="input-box"
                      placeholder="Google address.."
                      style={{ minHeight: "131px" }}
                      {...field}
                      readOnly
                    />
                  </div>
                )}
              />
            </div>

            {/* Manual Address */}
            <div className="col-md-11">
              <Controller
                control={control}
                name="manualAddress"
                disabled={type === "view"}
                rules={{ required: "Manual Address is Required *" }}
                render={({ field }) => (
                  <div style={{ width: "95%" }}>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Head/ Owner (Manual Address)
                    </label>
                    <textarea
                      className="input-box"
                      placeholder="Manual Address..."
                      {...field}
                      style={{ minHeight: "131px" }}
                    />
                    {errors.manualAddress && (
                      <p style={{ color: "red" }}>
                        {errors.manualAddress.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>

            {/* GST Details */}
            <div className="col-md-12">
              <div className="d-flex" style={{ alignItems: "center", gap: 10 }}>
                <label className="f-w700 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  GST details (optional)
                </label>
                <div
                  className={`toggle-switch ${isOn ? "on" : "off"}`}
                  onClick={toggleSwitch}
                >
                  <div className="toggle-knob" />
                </div>
              </div>
              {isOn && (
                <div className={`gst-form-container ${isOn ? "show" : ""}`}>
                  <div className="d-flex flex-wrap gap-5 mt-3">
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="GSTNo"
                        disabled={type === "view"}
                        rules={
                          isOn ? { required: "GST Number is required" } : {}
                        }
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              GST Number
                            </label>
                            <input
                              className="input-box"
                              placeholder="GST Number"
                              {...field}
                            />
                            {errors.GSTNo && (
                              <p style={{ color: "red" }}>
                                {errors.GSTNo.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="GSTholderName"
                        disabled={type === "view"}
                        rules={
                          isOn
                            ? { required: "GST Holder Name is required" }
                            : {}
                        }
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              GST Entity Name
                            </label>
                            <input
                              className="input-box"
                              placeholder="GST Entity Name"
                              {...field}
                            />
                            {errors.GSTholderName && (
                              <p style={{ color: "red" }}>
                                {errors.GSTholderName.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-11">
                      <Controller
                        control={control}
                        name="GSTAddress"
                        disabled={type === "view"}
                        render={({ field }) => (
                          <div style={{ width: "95%" }}>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              GST Address
                            </label>
                            <input
                              className="input-box"
                              placeholder="GST Address..."
                              {...field}
                            />
                            {errors.GSTAddress && (
                              <p style={{ color: "red" }}>
                                {errors.GSTAddress.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="GSTContactNo"
                        disabled={type === "view"}
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              GST contact number
                            </label>
                            <input
                              onInput={(e) =>
                                (e.target.value = e.target.value.slice(0, 10))
                              }
                              className="input-box"
                              type="number"
                              onKeyDown={(e) => {
                                if (
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown"
                                )
                                  e.preventDefault();
                              }}
                              placeholder="GST ContactNo"
                              {...field}
                            />
                            {errors.GSTContactNo && (
                              <p style={{ color: "red" }}>
                                {errors.GSTContactNo.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="GSTRegisterMail"
                        disabled={type === "view"}
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              GST Register Mail
                            </label>
                            <input
                              className="input-box"
                              type="email"
                              placeholder="GST Register Mail"
                              {...field}
                            />
                            {errors.GSTRegisterMail && (
                              <p style={{ color: "red" }}>
                                {errors.GSTRegisterMail.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Bank Details */}
            <div className="col-md-12">
              <div className="d-flex" style={{ alignItems: "center", gap: 10 }}>
                <label className="f-w700 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  Bank Details: (optional)
                </label>
                <div
                  className={`toggle-switch ${isOnbank ? "on" : "off"}`}
                  onClick={toggleSwitchs}
                >
                  <div className="toggle-knob" />
                </div>
              </div>
              {isOnbank && (
                <div className={`gst-form-container ${isOnbank ? "show" : ""}`}>
                  <div className="d-flex flex-wrap gap-5 mt-3">
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="bankName"
                        disabled={type === "view"}
                        rules={
                          isOnbank
                            ? {
                                required: "Bank Name is required",
                                pattern: {
                                  value: /^[A-Za-z ]+$/,
                                  message:
                                    "Only letters and spaces are allowed",
                                },
                              }
                            : {}
                        }
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              Bank Name
                            </label>
                            <input
                              className="input-box"
                              placeholder="Bank Name"
                              {...field}
                            />
                            {errors.bankName && (
                              <p style={{ color: "red" }}>
                                {errors.bankName.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="Branch"
                        disabled={type === "view"}
                        rules={
                          isOnbank
                            ? {
                                required: "Branch is required",
                                pattern: {
                                  value: /^[A-Za-z ]+$/,
                                  message:
                                    "Only letters and spaces are allowed",
                                },
                              }
                            : {}
                        }
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              Branch
                            </label>
                            <input
                              className="input-box"
                              placeholder="Branch"
                              {...field}
                            />
                            {errors.Branch && (
                              <p style={{ color: "red" }}>
                                {errors.Branch.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="IFSCCode"
                        disabled={type === "view"}
                        rules={
                          isOnbank
                            ? {
                                required: "IFSC Code is required",
                                pattern: {
                                  value: /^.{1,16}$/,
                                  message: "Enter Valid IFSC Number",
                                },
                              }
                            : {}
                        }
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              IFSC Code
                            </label>
                            <input
                              onInput={(e) =>
                                (e.target.value = e.target.value.slice(0, 16))
                              }
                              className="input-box"
                              placeholder="IFSC Code"
                              {...field}
                            />
                            {errors.IFSCCode && (
                              <p style={{ color: "red" }}>
                                {errors.IFSCCode.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="AccountHolderName"
                        disabled={type === "view"}
                        rules={
                          isOnbank
                            ? {
                                required: "Account Holder Name is required",
                                pattern: {
                                  value: /^[A-Za-z ]+$/,
                                  message:
                                    "Only letters and spaces are allowed",
                                },
                              }
                            : {}
                        }
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              Account Holder Name
                            </label>
                            <input
                              className="input-box"
                              placeholder="Account Holder Name"
                              {...field}
                            />
                            {errors.AccountHolderName && (
                              <p style={{ color: "red" }}>
                                {errors.AccountHolderName.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="AccountNumber"
                        disabled={type === "view"}
                        rules={
                          isOnbank
                            ? { required: "Account Number is required" }
                            : {}
                        }
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              Account Number
                            </label>
                            <input
                              className="input-box"
                              placeholder="Account Number"
                              type="number"
                              onKeyDown={(e) => {
                                if (
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown"
                                )
                                  e.preventDefault();
                              }}
                              {...field}
                            />
                            {/* FIX 6: Was showing AccountHolderName error here — now correctly shows AccountNumber error */}
                            {errors.AccountNumber && (
                              <p style={{ color: "red" }}>
                                {errors.AccountNumber.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="UPIID"
                        disabled={type === "view"}
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              UPI ID
                            </label>
                            <input
                              className="input-box"
                              placeholder="UPI ID"
                              {...field}
                            />
                            {errors.UPIID && (
                              <p style={{ color: "red" }}>
                                {errors.UPIID.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="GpayNumber"
                        disabled={type === "view"}
                        rules={
                          isOnbank
                            ? {
                                pattern: {
                                  value: /^[0-9]{10}$/,
                                  message:
                                    "Gpay number must be exactly 10 digits",
                                },
                              }
                            : {}
                        }
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              Gpay Number
                            </label>
                            <input
                              onInput={(e) =>
                                (e.target.value = e.target.value.slice(0, 10))
                              }
                              className="input-box"
                              placeholder="GpayNumber"
                              type="number"
                              onKeyDown={(e) => {
                                if (
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown"
                                )
                                  e.preventDefault();
                              }}
                              {...field}
                              onChange={(e) => {
                                if (e.target.value?.length > 10) return;
                                field.onChange(e);
                              }}
                            />
                            {errors.GpayNumber && (
                              <p style={{ color: "red" }}>
                                {errors.GpayNumber.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      {/* FIX 7: Removed misplaced onInput from Controller — moved correctly to the input element */}
                      <Controller
                        control={control}
                        name="PhonePayNumber"
                        disabled={type === "view"}
                        rules={
                          isOnbank
                            ? {
                                pattern: {
                                  value: /^[0-9]{10}$/,
                                  message:
                                    "PhonePay number must be exactly 10 digits",
                                },
                              }
                            : {}
                        }
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              Phone Pay Number
                            </label>
                            <input
                              className="input-box"
                              placeholder="Phone Pay Number"
                              type="number"
                              onInput={(e) =>
                                (e.target.value = e.target.value.slice(0, 10))
                              }
                              onKeyDown={(e) => {
                                if (
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown"
                                )
                                  e.preventDefault();
                              }}
                              {...field}
                              onChange={(e) => {
                                if (e.target.value?.length > 10) return;
                                field.onChange(e);
                              }}
                            />
                            {errors.PhonePayNumber && (
                              <p style={{ color: "red" }}>
                                {errors.PhonePayNumber.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <Controller
                        control={control}
                        name="panNumber"
                        disabled={type === "view"}
                        rules={{
                          pattern: {
                            value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                            message: "Enter valid PAN (e.g. ABCDE1234F)",
                          },
                        }}
                        render={({ field }) => (
                          <div>
                            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                              PAN Number (optional)
                            </label>
                            <input
                              className="input-box"
                              placeholder="ABCDE1234F"
                              type="text"
                              maxLength={10}
                              style={{ textTransform: "uppercase" }}
                              {...field}
                              onChange={(e) => {
                                field.onChange(e.target.value.toUpperCase());
                              }}
                            />
                            {errors.panNumber && (
                              <p style={{ color: "red" }}>
                                {errors.panNumber.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {type !== "view" && (
              <div
                className="col-lg-11 justify-content-end d-flex"
                style={{ width: "87%" }}
              >
                <button
                  type="submit"
                  className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                >
                  Submit
                </button>
              </div>
            )}
          </form>
        ) : (
          <OverallPropertiesList owner_id={Ownerid} />
        )}
      </div>
    </>
  );
};;

export default UserForm;
